/* @flow */

import { call, put, take } from 'redux-saga/effects'

import type { Action } from '../types'

import {
  getUserFromLegacyResponse,
  getSettingsFromLegacyLoginResponse,
  hardcodedRoles,
} from '../legacy'
import {
  localStorageGetItem,
  SagaMalfunctionError,
  sagaHandleError,
  BadResponseError,
  isAuthenticated,
  localStorageSetItem,
} from '../helpers'
import { setIsCurrentUserFetched } from '../stores/isCurrentUserFetched'
import { setCurrentUserId } from '../stores/currentUser'
import { setCurrentSettings } from '../stores/currentSettings'
import { setIsFetchingCurrentUserInitially } from '../stores/pending'

import { OPINARY_USER, intoUsersStore } from '../stores/usersStore'
import { intoRolesStore } from '../stores/rolesStore'
import {
  intoCustomersStore,
  mapUserToCustomerStore,
} from '../stores/customersStore'
import { fetchInitialData } from './fetchInitialData'
import { sagaLogoutUnauthorizedUser } from './logout'

import { sagaGet } from '../fetch'
import { GATEWAY_API_URL } from '../urls'

export const FETCH_CURRENT_USER_INITIALLY: string =
  'opinary/FETCH_CURRENT_USER_INITIALLY'

export function fetchCurrentUserInitially(): Action {
  return {
    type: FETCH_CURRENT_USER_INITIALLY,
  }
}

export function* sagaFetchCurrentUserDetails(): Generator<*, void, *> {
  const response = yield call(sagaGet, `${GATEWAY_API_URL}/v1/user-config`)

  if (response.status === 401 || response.status === 403 || !isAuthenticated())
    return yield call(sagaLogoutUnauthorizedUser)
  if (response.status !== 200) throw new BadResponseError(response)
  return yield call([response, response.json])
}

export function* sagaFetchCurrentUserInitially(): Generator<*, void, *> {
  let storedUser = localStorageGetItem(OPINARY_USER)

  if (!storedUser) {
    const userDetails = yield sagaFetchCurrentUserDetails()

    if (!userDetails) return

    yield call(localStorageSetItem, OPINARY_USER, userDetails.account)
    storedUser = userDetails.account
  }

  const user = getUserFromLegacyResponse(storedUser)

  yield put(intoRolesStore(hardcodedRoles))
  yield put(intoCustomersStore(mapUserToCustomerStore(user)))
  yield put(intoUsersStore([user]))
  yield put(setCurrentUserId(user.id))
  yield put(setCurrentSettings(getSettingsFromLegacyLoginResponse(storedUser)))
  yield put(setIsCurrentUserFetched(true))

  if (user && user.id) {
    yield put(fetchInitialData())
  }
}

export function* sagaRepeatedlyFetchCurrentUserInitially(): Generator<
  *,
  void,
  *
> {
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const action = yield take(FETCH_CURRENT_USER_INITIALLY)
    if (action == null) throw new SagaMalfunctionError()

    yield put(setIsFetchingCurrentUserInitially(true))

    try {
      yield call(sagaFetchCurrentUserInitially)
    } catch (err) {
      yield call(sagaHandleError, err)
    }

    yield put(setIsFetchingCurrentUserInitially(false))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/fetchCurrentUser.js